import React, { FunctionComponent, useEffect } from 'react';
import { ErrorModal as CommonErrorModal } from 'components/ErrorModal';
import CardPayment from 'scenes/common/components/Error/components/CardPayment';
import {
  customerCareNumber,
  format1300Number,
} from 'scenes/common/helpers/contacts';
import usePublishAnalyticsEvent, {
  AnalyticsEvent,
} from 'scenes/payments/hooks/useAnalytics';
import { ErrorType } from './types';

const unsuccessfulPaymentContent: string = `Please try again or call us on ${format1300Number(
  customerCareNumber()
)} to finalise your payment. Remember to take a note of your policy number.`;

const getModalData = (error: ErrorType) => {
  switch (error) {
    // TODO - add more error types
    case ErrorType.PaymentUnsuccessful:
    default:
      return {
        header: `Sorry, we're having trouble processing your payment`,
        content: unsuccessfulPaymentContent,
        isOpen: true,
        ImageComponent: CardPayment,
      };
  }
};

export const ErrorModal: FunctionComponent<{
  error: ErrorType;
  onClose: () => void;
}> = ({ error, onClose }) => {
  const { header, content, isOpen, ImageComponent } = getModalData(error);
  const analyticsErrorEvent = usePublishAnalyticsEvent(AnalyticsEvent.ERROR);

  useEffect(() => {
    analyticsErrorEvent(unsuccessfulPaymentContent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CommonErrorModal
      header={header}
      content={content}
      isOpen={isOpen}
      ImageComponent={ImageComponent}
      onClose={onClose}
    />
  );
};

export default ErrorModal;
